import React from 'react';
import { WidgetHeader } from '../common/widgetHeader.jsx';
import { translate } from '../../common/translation/translate';
import { smallMediaQuery, mediumMediaQuery } from '../../common/utilities/sizeHelpers';
import { ArrowIcon } from '../common/utilities/arrowIcon.tsx';
import { VideoPlayIcon }  from '../common/utilities/svg/videoPlayIcon';
import styled from 'styled-components';

import { LazyLoadImg } from '../../common/utilities/lazyLoadImg.js';
import { getWidgetHeaderText } from '../../common/utilities/getWidgetHeaderUtil';

export const NationalOutlookWidget = ({ linkUrl, poster }) =>
{
    return (
        <NationalOutlookWidgetContainer href={linkUrl} >
            <HeaderLinkContainer>
                <WidgetHeader
                    headerText={getWidgetHeaderText({ widgetTitle:translate('todaysNationalOutlook') })}
                    iconStyle={{ transform: 'rotate(-90deg)' }}>
                    <ArrowIconContainer>
                        <ArrowIcon />
                    </ArrowIconContainer>
                </WidgetHeader>
            </HeaderLinkContainer>
            <BodyContainer>
                <WidgetBodyWrap>
                    <LazyLoadImg style={outlookWidgetImageStyle}
                        width='100%'
                        height='100%'
                        alt='WeatherBug National Forecast Outlook'
                        src={poster}
                    />
                    <WidgetPlay>
                        <VideoPlayIcon width={40} height={40} />
                    </WidgetPlay>
                </WidgetBodyWrap>
            </BodyContainer>
        </NationalOutlookWidgetContainer>
    );
};

NationalOutlookWidget.DisplayName = 'NationalOutlookWidget';

const outlookWidgetImageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
};

const NationalOutlookWidgetContainer = styled.a`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-decoration: none;
    background: #ffffff;
    height: 320px;
    width: 100%;
    cursor: pointer;
    @media ${mediumMediaQuery} {
        height: 195px;
    }
    @media ${smallMediaQuery} {
        height: 170px;
    }
`;

const HeaderLinkContainer = styled.div`
    display: flex;
    cursor: pointer;
    background: #ffffff;
    width: 100%;
    height: 37px;
`;

const BodyContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 283px;
    @media ${mediumMediaQuery} {
        height: 158px;
    }
    @media ${smallMediaQuery} {
        height: 133px;
    }
    background: #ffffff;
    position: relative;

`;

const WidgetBodyWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    height: 100%;
`;

const WidgetPlay = styled.span`
    position: absolute;
    bottom: 8px;
    left: 8px;
    display: inline-block;
    z-index: 25;
    cursor: pointer;
    opacity: .75;
    transition: opacity .15s ease-in-out;
    &:hover{
        opacity: 1;
    }
`;

const ArrowIconContainer = styled.svg`
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -3px;
    margin-left: -3px;
    fill: #666;
    stroke-width: 1px;
    stroke: #666;
    width: 10px;
    height: 7px;
`;
